<template>
    <div>
        <NavBar/>
        <ChangePassword/>

    </div>
</template>

<script>

    import NavBar from '../components/NavBar.vue';
    import ChangePassword from '../components/ChangePassword.vue';

    export default {
        name: 'Configuracoes',
        components: {
            NavBar,
            ChangePassword
        }
    }

</script>